import React from 'react';

const Problem: React.FC = () => {
  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <div className="font-serif text-4xl font-light leading-tight tracking-tight text-gray-900 mb-8">
          People used to be relationships. Now they're contacts disguised as connections.
        </div>
        <div className="font-serif text-4xl font-light leading-tight tracking-tight text-gray-900 mb-8">
          More data, more features, more noise. It's like trying to find your keys in a hoarder's garage.
        </div>
        <div className="font-serif text-4xl font-light leading-tight tracking-tight text-gray-900 mb-8">
          CRM was a lie. A beautiful, expensive lie that promised to make you better at relationships but actually just made you better at data entry.
        </div>
        <div className="font-serif text-4xl font-light leading-tight tracking-tight text-gray-900">
          We're building Relatable for people who still believe relationships are worth remembering. The kind of people who actually care about the human behind the contact.
        </div>
      </div>
    </section>
  );
};

export default Problem; 